module.exports = __webpack_public_path__ + "img/ssl.d8ffb329.svg";